<template>
  <div class="pdf-password-dialog-container" v-if="show">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content">
        <weex-image
          v-if="allowDismissWithoutPassword"
          class="dialog-cross-image"
          @click="onDialogClose"
          :src="crossImage"
        ></weex-image>

        <div v-if="allowDismissWithoutPassword" class="dialog-content-below-cross"></div>
        <div v-else class="margin-top-20"></div>

        <weex-text
          v-if="fileName"
          style="word-break: break-word"
          class="font-size-sm-base text-color-black border-bottom padding-bottom-5"
          v-html="fileName"
        ></weex-text>

        <weex-text
          v-if="message"
          class="font-size-sm-base margin-top-20 text-color-red"
          v-html="message"
        ></weex-text>

        <div class="margin-top-10">
          <weex-text class="input_label">Password</weex-text>
          <input
            class="input_with_border_bottom"
            :value="password"
            @input="password=$event.target.value"
          />
        </div>

        <wxc-button
          text="Continue"
          class="horizontal-center margin-top-20"
          type="blue"
          size="small"
          @wxcButtonClicked="onContinueClicked"
        ></wxc-button>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import AlertService from "../core/alert/AlertService";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";

export default {
  name: "FilePasswordDetailsDialog",
  components: { WxcButton, WxcOverlay },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    allowDismissWithoutPassword: {
      type: Boolean,
      default: true
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    fileName: "",
    password: "",
    message: ""
  }),

  methods: {
    initFilePasswordDialog(fileName, message) {
      this.password = "";
      this.fileName = fileName;
      this.message = message;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    onDialogClose() {
      this.$emit("onDialogClose");
    },

    onContinueClicked() {
      if (this.checkForValidation()) {
        this.$emit("onPasswordEntered", this.password);
      }
    },

    checkForValidation() {
      if (!this.password) {
        this.showToast(MessageConstants.ENTER_FILE_PASSWORD);
        return false;
      }

      return true;
    }
  },

  computed: {
    crossImage() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CANCEL_RED);
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.pdf-password-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
